import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const MasterFormsList = Loadable(
  lazy(() =>
    import("./masterFormsList").then(({ MasterFormsList }) => ({
      default: MasterFormsList,
    }))
  )
);

const ManageMasterForms = Loadable(
  lazy(() =>
    import("./manageMasterForms").then(({ ManageMasterForms }) => ({
      default: ManageMasterForms,
    }))
  )
);

export const masterFormsRoutes = [
  {
    path: "/master-forms",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_FORM]}>
        <MasterFormsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/master-forms/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_FORM]}>
        <ManageMasterForms />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/master-forms/manage/:masterFormId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_FORM]}>
        <ManageMasterForms />
      </AuthorizedRoute>
    ),
  },
];
